import type { MenuConfig } from '@/config/navigation/types';
import { z } from 'zod';

/**
 * Zod schema for API validation — PascalCase matching backend response.
 * Intentionally flat (not a discriminated union) because z.lazy() recursive
 * schemas don't compose well with z.discriminatedUnion(). Runtime discrimination
 * happens in transformer.ts via 'Type' in item checks.
 */
export const menuItemSchema: z.ZodType<MenuConfig> = z.object({
  Code: z.string().default(''),
  Label: z.string(),
  Icon: z.string().optional(),
  Roles: z.preprocess((val) => val ?? [], z.array(z.string())),
  Hidden: z.boolean().optional(),
  IsGroup: z.literal(true).optional(),
  Type: z.enum(['legacy', 'native']).optional(),
  LegacyUrl: z.string().optional(),
  LegacyMode: z.string().optional(),
  LegacyQs: z.string().optional(),
  Route: z.string().optional(),
  Children: z.lazy(() => z.array(menuItemSchema)).optional()
}) as z.ZodType<MenuConfig>;

export const menuConfigResponseSchema = z.object({
  Items: z.array(menuItemSchema),
  Version: z.number(),
  HomeRedirect: z.string().nullable().optional(),
  LastUpdated: z.string().nullable().optional(),
  RecordVersion: z.number().nullable().optional()
});

export type MenuConfigResponse = z.infer<typeof menuConfigResponseSchema>;

export const menuConfigApiResponseSchema = z.object({
  Data: menuConfigResponseSchema.nullable().optional(),
  Error: z.boolean().optional(),
  ErrorMessage: z.string().nullable().optional()
});
